import { MoneyVariant } from './types';

function getPriceFormatCode(locale = 'en-US') {
  // Next locales are not a valid BCP-47 locale, which Int.NumberFormat uses.
  // Return valid BCP-47 locale string for a given Next locale.
  switch (locale) {
    case 'fr':
      return 'fr-FR';
    case 'de':
      return 'de-DE';
    case 'nl':
      return 'nl-NL';
    case 'es':
      return 'es-ES';
    default:
      return locale;
  }
}

export function formatMoney(
  money: MoneyVariant | null,
  locale = 'en-US',
  hideDecimals?: boolean,
) {
  if (!money) return null;

  let moneyPrefx = '';

  switch (locale) {
    case 'en-AU':
      moneyPrefx = 'AUD ';
  }

  locale = getPriceFormatCode(locale);

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: money?.currencyCode,
    minimumFractionDigits: hideDecimals ? 0 : 2,
    maximumFractionDigits: hideDecimals ? 0 : 2,
  });

  return `${moneyPrefx}${formatter.format(money.amount)}`;
}

export function parseNumber(value?: string): number | undefined {
  if (!value) return undefined;

  const parsedValue = parseInt(value, 10);
  return isNaN(parsedValue) ? undefined : parsedValue;
}
